
import queryDominios, { type BulaDominioRequest, type BulaDominioResponse, type BulaDominioIten } from 'bula-certa-commons/service/bulas/query-bulas-dominios'

export {
    type BulaDominioRequest, type BulaDominioResponse, type BulaDominioIten
}

export default queryDominios